import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { FormAwareSelectInput } from '@/components/form/formAwareInputs/FormAwareSelectInput';
import { FormLayoutItem, FormLayoutRow } from '@/components/layout/FormLayout';
import { useFormContext } from '@/components/react-hook-form';
import { useFeatureFlag } from '@/modules/featureFlags/useFeatureFlag';

import { TRUST_TAX_STATUS_ITEMS } from '../TaxStatusSubform/TaxStatusSubform.constants';
import { GenericTrustTaxStatus } from '../TaxStatusSubform/TaxStatusSubform.types';
import { getTaxStatusValuesFromEntityKind } from '../TaxStatusSubform/TaxStatusSubform.utils';
import {
  HypotheticalDraftEntityType,
  isHypotheticalDraftTrustType,
} from './draftEntities.constants';

export interface DraftEntityTaxStatusFormFields {
  draftEntityType: HypotheticalDraftEntityType | '';
  draftEntityTaxStatus: GenericTrustTaxStatus | '';
}

export function DraftEntityTaxStatusField() {
  const isTrustIncomeTaxEnabled = useFeatureFlag('trust_income_tax');
  const { control, setValue } =
    useFormContext<DraftEntityTaxStatusFormFields>();
  const draftEntityType = useWatch({
    control,
    name: 'draftEntityType',
  });
  const isDraftTrust = isHypotheticalDraftTrustType(draftEntityType);

  useEffect(() => {
    const defaultTaxStatus = draftEntityType
      ? getTaxStatusValuesFromEntityKind(draftEntityType).taxStatus
      : '';
    setValue('draftEntityTaxStatus', defaultTaxStatus);
  }, [draftEntityType, setValue]);

  if (!isTrustIncomeTaxEnabled || !isDraftTrust) {
    return null;
  }

  return (
    <FormLayoutRow>
      <FormLayoutItem>
        <FormAwareSelectInput<DraftEntityTaxStatusFormFields>
          control={control}
          fieldName="draftEntityTaxStatus"
          required
          label="Tax status"
          options={TRUST_TAX_STATUS_ITEMS}
        />
      </FormLayoutItem>
    </FormLayoutRow>
  );
}
